module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "mentor-selector"
  }, [(_vm.selectedMentor) ? _c('div', {
    staticClass: "modal-wrapper",
    on: {
      "click": function($event) {
        _vm.selectedMentor = null
      }
    }
  }, [_c('div', {
    staticClass: "modal-box",
    style: ({
      backgroundImage: 'url(' + _vm.selectedMentor.featuredImage + ')'
    }),
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.selectedMentor.avatar
    }
  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.selectedMentor.user.firstName) + " " + _vm._s(_vm.selectedMentor.user.lastName))]), _vm._v(" "), _c('div', {
    staticClass: "template-selector"
  }, [_c('span', [_vm._v("Template")]), _vm._v(" "), _c('ol', _vm._l((_vm.requestTemplates), function(tmpl, index) {
    return _c('li', {
      class: {
        selected: index === _vm.requestTemplateSelected
      }
    }, [_c('button', {
      attrs: {
        "type": "button",
        "disabled": _vm.submittingRequest
      },
      on: {
        "click": function($event) {
          _vm.setRequestTemplate(index)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(String.fromCharCode(65 + index)) + "\n                  ")])])
  }))]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.request),
      expression: "request"
    }],
    attrs: {
      "disabled": _vm.submittingRequest
    },
    domProps: {
      "value": (_vm.request)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.request = $event.target.value
      }
    }
  }), _vm._v(" "), _c('file-select', {
    attrs: {
      "multiple": "",
      "disabled": _vm.submittingRequest
    },
    model: {
      value: (_vm.requestFiles),
      callback: function($$v) {
        _vm.requestFiles = $$v
      },
      expression: "requestFiles"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "disabled": _vm.submittingRequest
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.sendRequest()
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.submittingRequest ? 'Submitting...' : 'Submit') + "\n            ")])], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [(!_vm.connectionAllowed) ? _c('h3', {
    staticClass: "disabled"
  }, [_vm._v("Mentor Selections will become available closer to the Mentorship Term."), _c('br'), _vm._v("You will be notified once this function becomes available.")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "selector"
  }, [(_vm.canSeeVenueOptions) ? _c('div', [(!_vm.isDirector) ? _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.venueFilter),
      expression: "venueFilter"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.venueFilter = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [(!_vm.localStorage.roles.includes('Student')) ? _c('option', {
    attrs: {
      "value": "both"
    }
  }, [_vm._v("Online & On-Campus "), (_vm.localStorage.path == '9200') ? _c('span', [_vm._v("Houdini")]) : _vm._e(), _vm._v(" Mentors")]) : _vm._e(), _vm._v(" "), _c('option', {
    attrs: {
      "value": "online"
    }
  }, [_vm._v("Online "), (_vm.localStorage.path == '9200') ? _c('span', [_vm._v("Houdini")]) : _vm._e(), _vm._v(" Mentors")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "campus"
    }
  }, [_vm._v("On-Campus "), (_vm.localStorage.path == '9200') ? _c('span', [_vm._v("Houdini")]) : _vm._e(), _vm._v(" Mentors")])])]) : _vm._e(), _vm._v(" "), (_vm.isDirector) ? _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.venueFilter),
      expression: "venueFilter"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.venueFilter = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "both"
    }
  }, [_vm._v("Online & On-Campus Mentors")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "online"
    }
  }, [_vm._v("Online Mentors")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "campus"
    }
  }, [_vm._v("On-Campus Mentors")])])]) : _vm._e(), _vm._v(" "), (_vm.isDirector) ? _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pathFilter),
      expression: "pathFilter"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.pathFilter = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "cgasset"
    }
  }, [_vm._v("CG Asset Mentors")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "houdini"
    }
  }, [_vm._v("Houdini Mentors")])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "filters"
  }, [_vm._v("\n                    Works in the\n                    "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.perfectMatch.industry),
      expression: "perfectMatch.industry"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.perfectMatch.industry = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "default": "",
      "selected": ""
    }
  }, [_vm._v("choose")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "vfx"
    }
  }, [_vm._v("VFX / Film & TV Industry")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "video_games"
    }
  }, [_vm._v("Video Game Industry")])]), _vm._v(",\n                    that is available\n\n                    "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.perfectMatch.availableDays),
      expression: "perfectMatch.availableDays"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.perfectMatch.availableDays = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "default": "",
      "selected": ""
    }
  }, [_vm._v("choose")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "weekdays"
    }
  }, [_vm._v("during the week")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "weekends"
    }
  }, [_vm._v("during the weekends")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "both"
    }
  }, [_vm._v("anytime of the week")])]), _vm._v(",\n\n                    "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.perfectMatch.availableTimes),
      expression: "perfectMatch.availableTimes"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.perfectMatch.availableTimes = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "default": "",
      "selected": ""
    }
  }, [_vm._v("choose")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "mornings"
    }
  }, [_vm._v("in the mornings")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "afternoons"
    }
  }, [_vm._v("in the afternoons")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "evenings"
    }
  }, [_vm._v("in the evenings")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "any"
    }
  }, [_vm._v("anytime of the day")])]), _vm._v(",\n\n\n                    "), _c('br'), _vm._v("That specializes in:\n\n                    "), _c('ul', {
    staticClass: "specialties"
  }, _vm._l((_vm.specialties), function(specialty) {
    return _c('li', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.perfectMatch.specialties),
        expression: "perfectMatch.specialties"
      }],
      attrs: {
        "type": "checkbox",
        "id": specialty
      },
      domProps: {
        "checked": _vm.perfectMatch.specialties.indexOf(specialty) > -1,
        "value": specialty,
        "checked": Array.isArray(_vm.perfectMatch.specialties) ? _vm._i(_vm.perfectMatch.specialties, specialty) > -1 : (_vm.perfectMatch.specialties)
      },
      on: {
        "__c": function($event) {
          var $$a = _vm.perfectMatch.specialties,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = specialty,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.perfectMatch.specialties = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.perfectMatch.specialties = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.perfectMatch.specialties = $$c
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": specialty
      }
    }, [_vm._v("\n                                " + _vm._s(_vm._f("deslugify")(specialty)) + "\n                            ")])])
  })), _vm._v(" "), _c('div', {
    staticClass: "form-group term-selector"
  }, [_vm._v("\n                    Term: "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedTerm),
      expression: "selectedTerm"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedTerm = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.getMentors()
      }]
    }
  }, _vm._l((_vm.terms), function(term) {
    return _c('option', {
      domProps: {
        "value": term.id
      }
    }, [_vm._v("\n                                " + _vm._s(term.name.split(',')[1].trim()) + "\n                            ")])
  }))])])]), _vm._v(" "), (_vm.loading) ? _c('div', [_c('loader')], 1) : _vm._e(), _vm._v(" "), (_vm.mentors) ? _c('ul', {
    staticClass: "mentors"
  }, _vm._l((_vm.mentors), function(mentor) {
    return (_vm.showMentor(mentor)) ? _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.selectionHasNotStarted || mentor.percentage > 0),
        expression: "selectionHasNotStarted || mentor.percentage > 0"
      }]
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'mentorProfile',
          params: {
            id: mentor.user.id
          }
        }
      }
    }, [_c('div', {
      staticClass: "mentor",
      class: {
        'unavailable': _vm.isNotAvailable(mentor)
      }
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-3 nopad avatar-wrapper"
    }, [_c('img', {
      staticClass: "avatar",
      attrs: {
        "src": mentor.avatar
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-9 nopad header"
    }, [_c('span', {
      staticClass: "name",
      attrs: {
        "title": mentor.user.firstName + ' ' + mentor.user.lastName
      }
    }, [_vm._v("\n                                      " + _vm._s(mentor.user.firstName) + " " + _vm._s(mentor.user.lastName) + "\n                                    ")]), _vm._v(" "), _c('span', {
      staticClass: "position",
      attrs: {
        "title": mentor.position
      }
    }, [_vm._v("\n                                      " + _vm._s(mentor.position) + "\n                                    ")]), _vm._v(" "), (mentor.company) ? _c('span', {
      staticClass: "company",
      attrs: {
        "title": mentor.company.replace(/ and /g, ' & ')
      }
    }, [_c('a', {
      attrs: {
        "href": mentor.companyUrl,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    }, [_vm._v("\n                                        " + _vm._s(mentor.company.replace(/ and /g, ' & ')) + "\n                                      ")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "featured-image-wrapper"
    }, [(_vm.isValidImage(mentor.featuredImage)) ? _c('v-lazy-image', {
      staticClass: "featured-image",
      attrs: {
        "src": mentor.featuredImage
      }
    }) : _c('img', {
      staticClass: "placeholder",
      attrs: {
        "src": require("../assets/img/logo-large.png")
      }
    }), _vm._v(" "), (mentor.public && (_vm.localStorage.roles.includes('OnlineDirector') || _vm.localStorage.roles.includes('CampusDirector'))) ? _c('div', {
      staticClass: "public-image"
    }, [_c('img', {
      staticClass: "software-image",
      attrs: {
        "src": require("../assets/img/mentor-public.svg")
      }
    })]) : _vm._e(), _vm._v(" "), (mentor.totalRequests > 0) ? _c('span', {
      staticClass: "past-mentees"
    }, [_vm._v("Mentored " + _vm._s(mentor.totalRequests))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "footer clearfix"
    }, [(!_vm.localStorage.roles.includes('CampusStudent')) ? _c('ul', {
      staticClass: "current-mentees"
    }, _vm._l((mentor.mentor_availabilities[0].seats), function(n) {
      return _c('li', [_c('span', {
        staticClass: "checkbox"
      }, [_c('i', {
        staticClass: "fa fa-check",
        class: {
          'green': (n - 1) < mentor.user.mentor_requests.length
        }
      })])])
    })) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "link"
    }, [_vm._v("View Profile")])])])])], 1) : _vm._e()
  })) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', [_vm._v("Discover Your Mentor")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6d76de6a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MentorSelector.vue
// module id = 2073
// module chunks = 2